<template>
  <div class="allCourses fl">
    <div class="title">
      <span
        :class="{'curspan':suoyin==index}"
        v-for="(item,index) in tabs"
        :key="index"
        @click="changeTab(index)"
      >{{item}}</span>
      <select class="selection-component mui-select" @click="all_()" >
        <img src="../assets/stop_j.png" alt="">
        <img src="../assets/stop_x.png" alt="">
        <option :value ="a" v-for="(a,index) in kecheng_year" :key='index'>{{a}}年</option>
      </select>
      <select class="selection-component" @click="all_type()" v-show="bol">
        <option :value ="b.name" v-for="(b,index) in kecheng_type" :key='index'>{{b.name}}</option>
      </select>
    </div>
    <div class="content">
      <mypackage v-show="pack_bol"></mypackage>
      <!-- <ul class="clearfix" v-show="ul_bol">
        <li class="fl" v-for="item in allcourse" :key="item.id" @click="todetail(item.id)" style=" cursor: pointer;">
          <div class="kechengbox">
            <img :src="item.img_url" alt class="bigimg" />
            <div class="biaozhi">
              <img v-if="item.kemu==1" src="/static/images/personal/zyk.png" alt />
              <img v-else src="/static/images/personal/gxk.png" alt />
            </div>
            <div class="txt">
              <span>讲师:&nbsp;</span>
              {{item.jiangshi.name}}
              <span style="float:right;font-size:12px;margin-right:5px;">购买后永久有效</span>
            </div>
          </div>
          <p class="tit">{{item.title}}</p>
          <div class="num">
            <div>
              学时：
              <span>{{item.xueshi_num}}</span>
            </div>
            <div>
              价格：
              <span>￥{{item.price}}元</span>
            </div>
          </div>
        </li>
      </ul> -->
      <div class="block" v-show="fenye">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="pageNo"
          :page-size="6"
          layout="total,prev, pager, next, jumper"
          :total="count"
          :pager-count="7"
          v-show="count>6"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import mypackage from './mypackage'
export default {
  data() {
    return {
      pack_bol:true,
      ul_bol:false,
      bol:false,
      kecheng_year:'',
      kecheng_type:'',
      pageNo: 1,
      count: 0,
      page: 1,
      year: "",
      uid: "",
      token: "",
      fenye: true,
      num: 6,
      allcourse: [],
      pagesize: 1,
      yenum: "",
      allxueshi: "",
      kechengxueshi: "",
      used: 0,
      id: [],
      idd: "",
      suoyin: 0,
      kemuid: "",
      tabs: ["全部课程", "专业课", "公需课"],
      
    };
  },
  created() {
    var that = this;
    this.uid = localStorage.getItem("uid");
    this.token = localStorage.getItem("token");
    var date = new Date();
    this.year = date.getFullYear();
    if (this.token) {
      
    if(sessionStorage.getItem('suoyin')==0){
       this.suoyin = sessionStorage.getItem('suoyin');
        this.kemuid = "";
        this.page=1
      }else if(sessionStorage.getItem('suoyin')==1){
         this.suoyin = sessionStorage.getItem('suoyin');
         this.kemuid = 1;
        this.page=1
      }else if(sessionStorage.getItem('suoyin')==2){
         this.suoyin = sessionStorage.getItem('suoyin');
          this.kemuid = 2;
          this.page=1
      }
      this.getallcourse();
    } else {
      this.removeInfo();
    }
  },
  watch: {
    token: {
      handler: function(val) {
        if (val) {
          // this.getallcourse();
        } else {
          this.removeInfo();
        }
      }
    },
    deep: true
  },
  methods: {
    all_type(){
      let that = this;
      this.$axios({
      method: 'get',
      url: '/kecheng/get_kecheng_type',
      }).then(function (response) {
        if(response.data.status=="ok"){
          // //console.log("课程类型")
          // //console.log(response.data.data)
          that.kecheng_type=response.data.data;
        }else if((response.data.status=="error")){
          that.$message.error({message:response.data.errormsg,duration:1600});
        }else if((response.data.status=="relogin")){
          that.removeInfo();
        }
        
      });
    },
    all_(){
      let that = this;
      //获取课程年份 
      this.$axios({
        method: 'get',
        url: '/kecheng/get_kecheng_year',
        }).then(function (response) {
          if(response.data.status=="ok"){
              // //console.log("课程年份")
              // //console.log(response.data.data)
              that.kecheng_year=response.data.data;
            }else if((response.data.status=="error")){
              that.$message.error({message:response.data.errormsg,duration:1600});
            }else if((response.data.status=="relogin")){
              that.removeInfo();
          }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.page = val;
      // //console.log(`当前页: ${val}`,123123);
      this.getallcourse();
    },
    removeInfo() {
      var that = this;
      localStorage.removeItem("uid");
      localStorage.removeItem("token");
      localStorage.removeItem("sex");
      localStorage.removeItem("name");
      localStorage.removeItem("mobile");
      localStorage.removeItem("id_card");
      setTimeout(() => {
        that.$router.push({ path: "/" });
      }, 500);
    },
    //获取公需课课程
    getallcourses() {
      var that = this;
      var datalist = {
        num: this.num,
        year: this.year,
        page: this.page,
        year: this.year,
        kemu: this.kemuid,
        type:'2'
      };
      this.$axios
        .post( "/kecheng/get_kecheng_list", qs.stringify(datalist))
        .then(res => {
          if (res.data.status == "ok") {
            // //console.log("公需课课程");
            // //console.log(res);
            that.allcourse = [];
            that.allcourse = that.allcourse.concat(res.data.data.data);
            that.count = parseInt(res.data.data.count);
            that.pagesize = res.data.data.pagesize;
            // //console.log(res.data.data.data);
            for (var i = 0; i < res.data.data.data.length; i++) {
              that.id = that.id.concat(res.data.data.data[i].id);
            }
            for (var i = 0; i < that.id.length; i++) {
              that.idd = that.id[i];
              // //console.log(this.idd);
            }
          } else if (res.data.status == "error") {
            this.$message.error({ message: res.data.errormsg, duration: 1600 });
          } else if (res.data.status == "relogin") {
            this.$message.error({ message: "重新登录", duration: 1600 });
            that.removeInfo();
          }
        });
    },
    //获取全部课程

    //获取专业课课程
    getallcourse() {
      var that = this;
      var datalist = {
        num: this.num,
        year: this.year,
        page: this.page,
        year: this.year,
        kemu: this.kemuid,
        type:'1'
      };
      this.$axios
        .post( "/kecheng/get_kecheng_list", qs.stringify(datalist))
        .then(res => {
          if (res.data.status == "ok") {
            // //console.log("获取专业课");
            // //console.log(res);
            that.allcourse = [];
            that.allcourse = that.allcourse.concat(res.data.data.data);
            that.count = parseInt(res.data.data.count);
            that.pagesize = res.data.data.pagesize;
            // //console.log(res.data.data.data);
            for (var i = 0; i < res.data.data.data.length; i++) {
              that.id = that.id.concat(res.data.data.data[i].id);
            }
            for (var i = 0; i < that.id.length; i++) {
              that.idd = that.id[i];
              // //console.log(this.idd);
            }
          } else if (res.data.status == "error") {
            this.$message.error({ message: res.data.errormsg, duration: 1600 });
          } else if (res.data.status == "relogin") {
            this.$message.error({ message: "重新登录", duration: 1600 });
            that.removeInfo();
          }
        });
    },
    //获取课程进度
    getprogress() {
      var that = this;
      that.$axios
        .post(
           "/kecheng/get_kecheng_jindu",
          qs.stringify({
            kecheng_id: that.id,
            uid: that.uid,
            token: that.token
          })
        )
        .then(res => {
          if (res.data.status == "ok") {
            // //console.log("获取进度");
            // //console.log(res);
            // //console.log(res.data.status);
            if (res.data.status == "error") {
              that.used = 0;
            } else {
              if (res.data.status == "ok") {
                that.used = res.data.progress;
              }
            }
          } else if (res.data.status == "error") {
            this.$message.error({ message: res.data.errormsg, duration: 1600 });
          } else if (res.data.status == "relogin") {
            this.$message.error({ message: "重新登录", duration: 1600 });
            that.removeInfo();
          }
        });
    },
    //到课程详情页
    todetail(val) {
      // //console.log(val);
      this.$router.push({
        name: "personcourseDetails",
        params: {
          courseId: val
        }
      });
    },
    
    changeTab: function(index) {
      this.suoyin = index;
      sessionStorage.setItem('suoyin',this.suoyin)
      if (index == 0) {
        this.kemuid = "";
        this.page=1;
        this.bol = false;
        this.pack_bol = true;
        this.ul_bol = false;
      } else if (index == 1) {
        this.kemuid = 1;
        this.page=1;
        this.bol = true;
        this.pack_bol = false;
        this.ul_bol = true;
        this.getallcourse();
      } else if (index == 2) {
        this.kemuid = 2;
        this.page=1;
        this.bol = false
        this.pack_bol = false;
        this.ul_bol = true;
        this.getallcourses();
        
      }
    }
  },
  mounted(){
    this.all();
  },
  components:{
    mypackage,
  }
 };
</script>

<style scoped lang="less">
.allCourses {
  width: 948px;
  background-color: #fff;
  .title {
    width: 100%;
    height: 55px;
    // margin-bottom: 20px;
    font-size: 18px;
    padding-left: 35px;
    line-height: 55px;
    color: #0c69f5;
    box-sizing: border-box;
    border-bottom: 2px solid #eee;
    span {
      margin-right: 20px;
      cursor: pointer;
      color: #b9b9b9;
    }
    .selection-component{
      height: 20px;
      width: 100px;
      float: right;
      color: #f00;
      font-size: 16px;
      margin: 21px 21px 0 0 ;
      padding:0 5px;
      position: relative;
      img{
        position: absolute;
        top:0;
        right: 0;
        height: 5px;
        width: 10px;
      }
    }
    .curspan {
      border-bottom: 2px solid #0c69f5;
      padding-bottom: 13px;
      color: #0169ca;
    }
  }
  .content {
    position: relative;
    width: 100%;
    min-height: 654px;
    ul {
      li {
        // border:1px solid red;
        width: 260px;
        // height: 285px;
        margin-left: 32px;
        margin-top: 15px;
        border: 1px solid #dfe4ed;
        border-radius: 5px;
        padding: 10px;
        cursor: pointer;
        .kechengbox {
          position: relative;
          .biaozhi {
            position: absolute;
            left: 0;
            top: 10px;
            img {
              width: 50px;
            }
          }
          .bigimg {
            width: 100%;
            height: 144px;
            //border-radius: 5px;
            overflow: hidden;
          }
          .txt {
            width: 100%;
            height: 34px;
            padding-left: 8px;
            background-color: rgba(0, 0, 0, 0.4);
            font-size: 14px;
            color: #fff;
            line-height: 34px;
            position: absolute;
            bottom: 0;
            //border-radius: 0 0 5px 5px;
          }
        }
        .num {
          padding-top: 8px;
          font-size: 13px;
          display: flex;
          justify-content: space-between;
          div {
            color: #000;
            span {
              color: red;
              font-size: 16px;
              font-weight: bold;
            }
          }
        }
        .tit {
          height: 22px;
          font-size: 16px;
          color: #000;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: 8px;
        }
      }
      li:hover {
        box-shadow: 0px 0px 20px #c1c1c1;
        border: 1px solid #c1c1c1;
      }
    }
    .block {
      position: absolute;
      bottom: 0;
      text-align: center;
      width: 100%;
      height: 52px;
      padding-top: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/allCourses.vue